import React, { Component } from 'react';

import Avatar from '../Avatar/Avatar';
import TeacherInformation from '../TeacherInformation/TeacherInformation';
import Video from '../Video/Video';

import './TeacherProfile.css';

class TeacherProfile extends Component {
  constructor(props) {
    super(props);

    this.defaultMaleImageUrl = 'https://images.rypeapp.com/teachers/male_avatar_1024x1024.jpg';
    this.defaultFemailImageUrl = 'https://images.rypeapp.com/teachers/female_avatar.jpg';
  }

  renderVideo(teacher) {
    const { videoUrl } = teacher; // || 'https://www.youtube.com/embed/ScMzIvxBSi4'

    if (videoUrl && this.props.showVideo) {
      return (
        <Video
          className="teacher-video flex-first flex-md-last"
          src={videoUrl}
          title={`${teacher.name} introduction video`}
        />
      );
    }
    return null;
  }

  render() {
    const { teacher } = this.props;
    const { name } = teacher;
    let avatarUrl = teacher.imageUrl;

    if (!avatarUrl) {
      if (teacher.gender === 'female') {
        avatarUrl = this.defaultFemailImageUrl;
      } else {
        avatarUrl = this.defaultMaleImageUrl;
      }
    }

    return (
      <div className="TeacherProfile">
        <div className="card flex-column flex-md-row flex-nowrap">
          {this.renderVideo(teacher)}

          <Avatar
            className="flex-md-first
                             align-self-center
                             align-self-md-start
                             m-3
                             my-md-4
                             ml-md-4
                             mr-md-0"
            imageClassName="avatar rounded-circle"
            src={avatarUrl}
            alt={name}
          />

          <TeacherInformation className="flex-unordered m-3 m-md-4" {...this.props} />
        </div>
      </div>
    );
  }
}

export default TeacherProfile;



// WEBPACK FOOTER //
// ./src/components/TeacherProfile/TeacherProfile.js